import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Button, InputGroup, Input, Form, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Field, reduxForm, change, formValueSelector } from 'redux-form'
import { DataTable, MainLoader } from '../../../../../components'
import PropTypes from 'prop-types'
import { getProductsOffer, resetProductsOffer } from '../../../../../store/product/actions'
import { getServicesOffer, resetServicesOffer } from '../../../../../store/service/actions'

import { formatHelper } from '../../../../../common/helpers'

class FormSelectItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            filter: '',
            page: 1,
            itemsSelected: []
        }

        this.onSubmitItem = this.onSubmitItem.bind(this)
        this.handleInputFilterChange = this.handleInputFilterChange.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    async componentDidMount() {
        const { getProductsOffer, getServicesOffer } = this.props
        const { page, filter } = this.state

        if (this.props.itemType == 'Productos')
            await getProductsOffer({ reset: true })
        else
            await getServicesOffer({ reset: true })
    }

    async onSubmitItem() {
        const { itemsSelected } = this.state
        const { singleSelect = true } = this.state
        if (itemsSelected.length > 0) {
            if (singleSelect)
                await this.props.onSubmitItem(itemsSelected[0])
            else
                await this.props.onSubmitItem(itemsSelected)
            this.props.toggleModal()
        }
    }

    async performGetItems() {
        const { getProductsOffer, getServicesOffer } = this.props
        const { page, filter } = this.state

        if (this.props.itemType == 'Productos')
            await getProductsOffer({ page: page, filter: filter })
        else
            await getServicesOffer({ page: page, filter: filter })
    }

    async filterItems() {
        await this.setState({ page: 1 })
        this.performGetItems()
    }

    async handleInputFilterChange(e) {
        if (e.key === 'Enter') {
            this.filterItems()
        }
    }

    async handlePageChange(page) {
        await this.setState({ page: page })
        this.performGetItems()
    }

    handleClickCheckBox(e, id) {
        let { itemsSelected } = this.state;
        const { products, services, singleSelect = true } = this.props;
        let data = []
        if (this.props.itemType == 'Productos')
            data = products
        else
            data = services

        if (!singleSelect) {
            const index = itemsSelected.findIndex(x => x.id == id);
            if (index == -1) itemsSelected.push(data.find(x => x.id == id));
            else itemsSelected = itemsSelected.remove(index);
        } else {
            itemsSelected = [];
            itemsSelected.push(data.find(x => x.id == id));
        }

        this.setState({ itemsSelected });
    }

    renderDataTable() {
        const columnCheckbox = {
            dataField: '',
            text: '',
            formatter: (cell, row) => {
                const { itemsSelected } = this.state;
                const entity = itemsSelected.find(x => x.id == row.id);
                return (
                    <div>
                        <div className="custom-control custom-checkbox">
                            <input
                                id={`check-${row.id}`}
                                type="checkbox"
                                className="custom-control-input"
                                checked={entity ? true : false}
                                onChange={e => this.handleClickCheckBox(e, row.id)}
                            />
                            <label className="custom-control-label" htmlFor={`check-${row.id}`} />
                        </div>
                    </div>
                )
            },
            style: { width: '50px' },
            headerStyle: { width: '50px' },
        }

        const columnsProduct = [
            {
                dataField: 'name',
                text: 'Nombre'
            },
            {
                dataField: 'category.name',
                text: 'Categoría'
            },
            {
                dataField: 'price',
                text: 'Precio (S/)',
                formatter: (cell, row) => {
                    return (
                        <span>{formatHelper.toMoney(row.price)}</span>
                    )
                }
            },
            columnCheckbox
        ]

        const columnsService = [
            {
                dataField: 'name',
                text: 'Nombre'
            },
            {
                dataField: 'price',
                text: 'Precio (S/)',
                formatter: (cell, row) => {
                    return (
                        <span>{formatHelper.toMoney(row.price)}</span>
                    )
                }
            },
            columnCheckbox
        ]
        const { products, productTotal, productPageSize, productLoading, services, serviceTotal, servicePageSize, serviceLoading, itemType } = this.props

        return (
            <DataTable
                data={(itemType == 'Productos') ? products : services}
                keyField='id'
                columns={(itemType == 'Productos') ? columnsProduct : columnsService}
                page={this.state.page}
                totalSize={(itemType == 'Productos') ? productTotal : serviceTotal}
                sizePerPage={(itemType == 'Productos') ? productPageSize : servicePageSize}
                loading={(itemType == 'Productos') ? productLoading : serviceLoading}
                onPageChange={this.handlePageChange}
            />
        )
    }

    render() {
        const { handleSubmit } = this.props
        return (
            <div>
                <ModalHeader>
                    {(this.props.itemType == 'Productos') ? <i className="icon-layers"></i> : <i className="icon-tag"></i>}  {this.props.itemType}
                </ModalHeader>
                <ModalBody>
                    <Row className='mb-2'>
                        <Col>
                            <InputGroup>
                                <Input type="text" placeholder='Buscar'
                                    value={this.state.filter}
                                    onChange={(e) => this.setState({ filter: e.target.value })}
                                    onKeyPress={this.handleInputFilterChange}
                                />
                                <div className="input-group-prepend">
                                    <Button color="primary" onClick={() => this.filterItems()} ><i className="fa fa-search"></i></Button>
                                </div>
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {this.renderDataTable()}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitItem))}>
                        <Row>
                            <Col className='mt-3'>
                                <Button type='submit' color='primary' className='mr-2'><i className="fa fa-save mr-1" /> Seleccionar</Button>
                                <Button color='secondary' onClick={() => this.props.toggleModal()} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalFooter>
            </div>
        );
    }
}

FormSelectItem.propTypes = {
    singleSelect: PropTypes.bool,
    itemType: PropTypes.string,
    onSubmitItem: PropTypes.func,
    toggleModal: PropTypes.func,
}

function mapStateToProps(state) {
    const { productOfferList } = state.product
    const { serviceOfferList } = state.service

    return {
        products: productOfferList.products,
        productError: productOfferList.error,
        productLoading: productOfferList.loading,
        productPageSize: productOfferList.pageSize,
        productTotal: productOfferList.total,
        services: serviceOfferList.services,
        serviceError: serviceOfferList.error,
        serviceLoading: serviceOfferList.loading,
        servicePageSize: serviceOfferList.pageSize,
        serviceTotal: serviceOfferList.total
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProductsOffer,
        resetProductsOffer,
        getServicesOffer,
        resetServicesOffer,
    }, dispatch)
}

export default reduxForm({
    form: 'OfferAddItemForm',
    touchOnBlur: false,
    // enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(FormSelectItem))


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferAdd/Forms/FormSelectItem.js